import '../../external/jquery.ui.touch-punch.min';
import { sliderOptionFormat } from './search_slider_format';

export const VEHICLE_KILOMETER_THRESHOLD_BANNA = {
    AUTO: 250000,
    MOTO: 100000,
};

export const sellVehicleKilometerSlider = {
    sliderName: '',
    valueElement: '',
    minimumValue: 0,
    maximumValue: 300000,
    stepSize: 5000, // Step size for increments
    sliderOptionsCount: 0,
    sliderStepWidth: 0,
    sliderMaximum: 580, // Keep this value a multiple of the length of the list
    list: [],
    generateList() {
        this.list = [this.minimumValue];

        // Generate values dynamically based on the step size
        for (let i = this.stepSize; i < this.maximumValue; i += this.stepSize) {
            this.list.push(i);
        }

        // Add the maximum value at the end
        this.list.push(this.maximumValue);

        this.sliderOptionsCount = this.list.length;
        this.sliderStepWidth = this.sliderMaximum / this.sliderOptionsCount;
    },
    init(optionsInput) {
        const options = optionsInput || {};
        this.sliderName = options.sliderName ? options.sliderName : $('#kilometerSlider');
        this.valueElement = options.valueElement ? options.valueElement : $('#kilometersValue');
        this.generateList();

        this.sliderName.slider({
            animate: true,
            range: 'min', // Single handle slider
            min: 0,
            max: this.sliderMaximum,
            create() {
                sellVehicleKilometerSlider.setSlider(sellVehicleKilometerSlider.valueElement.val());
                sellVehicleKilometerSlider.sliderFormat();
            },
            slide(event, ui) {
                const maxValIndex = sliderOptionFormat.getSliderIndex(
                    ui.value,
                    sellVehicleKilometerSlider.sliderOptionsCount,
                    sellVehicleKilometerSlider.sliderStepWidth
                );
                const maxVal = sellVehicleKilometerSlider.list[maxValIndex];
                sellVehicleKilometerSlider.valueElement.val(maxVal);
                sellVehicleKilometerSlider.sliderFormat(maxVal);
            },
            stop() {
                sellVehicleKilometerSlider.valueElement.trigger('change');
            },
        });
    },
    setSlider(valueInput) {
        let index = 0;
        let value = parseInt(valueInput, 10);
        if (value > 0) {
            value = sliderOptionFormat.getClosestOption(this.list, value);
            index = this.list.indexOf(value) * this.sliderStepWidth;
        }
        this.sliderName.slider('value', index);
        this.sliderFormat(value);
    },
    sliderFormat(maxValue) {
        const formattedValue = maxValue
            ? `<span>${commonUtils.number_format(maxValue, 0, ',', ' ')}</span> <span>km</span>`
            : '0 km';
        $('#kilometerRange').html(formattedValue);
    },
};
